import { render } from "./TaskTable.vue?vue&type=template&id=378b3662"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__